/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  LSP8CompatibilityForERC721,
  LSP8CompatibilityForERC721Interface,
} from "../LSP8CompatibilityForERC721";

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "name_",
        type: "string",
      },
      {
        internalType: "string",
        name: "symbol_",
        type: "string",
      },
      {
        internalType: "address",
        name: "newOwner_",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "LSP8CannotSendToAddressZero",
    type: "error",
  },
  {
    inputs: [],
    name: "LSP8CannotUseAddressZeroAsOperator",
    type: "error",
  },
  {
    inputs: [],
    name: "LSP8InvalidTransferBatch",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "tokenId",
        type: "bytes32",
      },
    ],
    name: "LSP8NonExistentTokenId",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "tokenId",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "caller",
        type: "address",
      },
    ],
    name: "LSP8NotTokenOperator",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenOwner",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "tokenId",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "caller",
        type: "address",
      },
    ],
    name: "LSP8NotTokenOwner",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenReceiver",
        type: "address",
      },
    ],
    name: "LSP8NotifyTokenReceiverContractMissingLSP1Interface",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenReceiver",
        type: "address",
      },
    ],
    name: "LSP8NotifyTokenReceiverIsEOA",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "tokenId",
        type: "bytes32",
      },
    ],
    name: "LSP8TokenIdAlreadyMinted",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "tokenOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "tokenId",
        type: "bytes32",
      },
    ],
    name: "AuthorizedOperator",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "key",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "value",
        type: "bytes",
      },
    ],
    name: "DataChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "tokenOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "tokenId",
        type: "bytes32",
      },
    ],
    name: "RevokedOperator",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "tokenId",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "force",
        type: "bool",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "tokenId",
        type: "bytes32",
      },
    ],
    name: "authorizeOperator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenOwner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32[]",
        name: "keys",
        type: "bytes32[]",
      },
    ],
    name: "getData",
    outputs: [
      {
        internalType: "bytes[]",
        name: "values",
        type: "bytes[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "tokenId",
        type: "bytes32",
      },
    ],
    name: "getOperatorsOf",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenOwner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "tokenId",
        type: "bytes32",
      },
    ],
    name: "isOperatorFor",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "tokenId",
        type: "bytes32",
      },
    ],
    name: "revokeOperator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32[]",
        name: "_keys",
        type: "bytes32[]",
      },
      {
        internalType: "bytes[]",
        name: "_values",
        type: "bytes[]",
      },
    ],
    name: "setData",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenOwner",
        type: "address",
      },
    ],
    name: "tokenIdsOf",
    outputs: [
      {
        internalType: "bytes32[]",
        name: "",
        type: "bytes32[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "tokenId",
        type: "bytes32",
      },
    ],
    name: "tokenOwnerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "tokenId",
        type: "bytes32",
      },
      {
        internalType: "bool",
        name: "force",
        type: "bool",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "transfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "from",
        type: "address[]",
      },
      {
        internalType: "address[]",
        name: "to",
        type: "address[]",
      },
      {
        internalType: "bytes32[]",
        name: "tokenId",
        type: "bytes32[]",
      },
      {
        internalType: "bool",
        name: "force",
        type: "bool",
      },
      {
        internalType: "bytes[]",
        name: "data",
        type: "bytes[]",
      },
    ],
    name: "transferBatch",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class LSP8CompatibilityForERC721__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    name_: string,
    symbol_: string,
    newOwner_: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<LSP8CompatibilityForERC721> {
    return super.deploy(
      name_,
      symbol_,
      newOwner_,
      overrides || {}
    ) as Promise<LSP8CompatibilityForERC721>;
  }
  getDeployTransaction(
    name_: string,
    symbol_: string,
    newOwner_: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      name_,
      symbol_,
      newOwner_,
      overrides || {}
    );
  }
  attach(address: string): LSP8CompatibilityForERC721 {
    return super.attach(address) as LSP8CompatibilityForERC721;
  }
  connect(signer: Signer): LSP8CompatibilityForERC721__factory {
    return super.connect(signer) as LSP8CompatibilityForERC721__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): LSP8CompatibilityForERC721Interface {
    return new utils.Interface(_abi) as LSP8CompatibilityForERC721Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): LSP8CompatibilityForERC721 {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as LSP8CompatibilityForERC721;
  }
}
